import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { AcqnDashboardDetails, AcquisitionDetails, SelectedReports } from '../../../model/AcquisitionDetails';
import { SelectItem } from '@fm-ui-adk/components-3/common/model';
import * as _ from 'lodash-es';
import { StatsDataDetails } from '../../model/StatsDataDetails';
import { AcqnFilterService } from 'src/app/services/acqn-filter-service';
import { AcqnFiltersDetails } from '../../model/AcqnFiltersDetails';
import { FilterDetailsSourceType } from 'src/app/shared/enum-value';
import { AcqnDownloadService } from 'src/app/services/acqn-download.service';
import { UserRoles } from 'src/app/model/UserRoles';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { StatsDataService } from 'src/app/services/stats-data.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { FileUploadSourceType } from 'src/app/shared/enum-value';




@Component({
  standalone: false,
  selector: 'app-acquisitions',
  templateUrl: './acquisitions.component.html',
  styleUrls: ['./acquisitions.component.css'],
  providers: [DashboardService]
})
export class AcquisitionsComponent implements OnInit {

  // https://angular.io/guide/component-interaction
  @Input() set acqnDetails(acqnDetails: AcquisitionDetails) {
    this._acqnDetails = acqnDetails;
    // this.resetDropDownPlaceHolders('tabChange');
    this.loadAcquistionTabData();
    this.applyFilters();
  }
  private _acqnDetails: AcquisitionDetails;

  @Input() selectStartPeriod: any[] = [];
  @Input() selectedStartPeriod: string = "";
  @Input() selectEndPeriod: any[] = [];
  @Input() selectedEndPeriod: string = "";

  @Input() numberOfAcquisitions: any;
  @Input() complianceRateAcquisitions: any;
  @Input() submissionRateAcquisitions: any;
  @Input() isInternal: boolean = false;
  @Input() showAcqnTableEditCheckbox: boolean = false;
  @Input() showUploadFiles;

  @Output() refreshAcqnDetails: EventEmitter<object> = new EventEmitter<object>();
  @Output() getEndPeriodDates: EventEmitter<object> = new EventEmitter<object>();
  @Output() openAcqnFilterSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() openAcqnPropertyDetailsSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedPropertyDetails: EventEmitter<object> = new EventEmitter<object>();
  @Output() propertyFileUploadPCADetails: EventEmitter<object> = new EventEmitter<object>();


  numberOfPreAcquisitionDeals: number = 0;
  countDiaplayedAqsnList: number = 0;

  showAcqnUpdateComponent = false;

  acqnDetailsDashboardDisplay: AcqnDashboardDetails[] = [];
  acqnDetailsDashboardDisplayTemp: AcqnDashboardDetails[];

  acqsnLenderList: any[] = [];
  acqsnSelectedLender: string = '';
  acquisitionStatusFilterList: any[] = [];
  acquisitionStatusFilterSelected: string = '';
  lnPurpsTypeList: SelectItem[] = [];
  lnPurpsTypeSelected: string = '';
  lnRefiTypeList: SelectItem[] = [];
  lnRefiTypeSelected: string = '';
  lnBalanceList: SelectItem[] = [];
  lnBalanceSelected: string = '';
  txTypeList: SelectItem[] = [];
  txTypeSelected: string = '';

  selectedReportArrayDisplay: SelectedReports[] = [];
  cols5: any[];

  filteredData = [];

  tableSearchText: string = '';

  userRoles: UserRoles;
  enableDownloadButton: boolean = false;  //Based on table row count
  showDownloadButton: boolean = false;  //Based on user role
  showUploadPCAButton: boolean = false;  //Based on user role

  constructor(private acqnDownloadService: AcqnDownloadService,
    private acqnFiltersService: AcqnFilterService,
    private userRolesService: UserRolesService,
    private fileUploadService: FileUploadService,
    private statsDataService: StatsDataService) {
  }

  ngOnInit(): void {

    // get user roles
    this.userRolesService.userRoles$.subscribe(data => {
      this.userRoles = data;
    });

    this.acqnFiltersService.acqnFiltersDetailsSub.subscribe((acqnFiltersDetails: AcqnFiltersDetails) => {
      if ((acqnFiltersDetails.source.includes(FilterDetailsSourceType.Acquisitions))  &&
         (acqnFiltersDetails.source.includes(FilterDetailsSourceType.AcqnFilter))) {
        this.selectedStartPeriod = acqnFiltersDetails.startPeriod;
        this.selectedEndPeriod = acqnFiltersDetails.endPeriod;
        this.isInternal = acqnFiltersDetails.isInternal;
        this.acqsnSelectedLender = acqnFiltersDetails.lender;
        this.acquisitionStatusFilterSelected = acqnFiltersDetails.acquisitionStatus;
        this.lnPurpsTypeSelected = acqnFiltersDetails.supplemental;
        this.lnRefiTypeSelected = acqnFiltersDetails.loanRefinanceType;
        this.lnBalanceSelected = acqnFiltersDetails.smallLoanBalance;
        this.txTypeSelected = acqnFiltersDetails.transactionType;

        this.applyFilters();
      }
    });

    this.cols5 = [
      { field: 'propNme', header: 'Property Name' },
      { field: 'dusDealId', header: 'DUS Gateway Deal ID' },
      { field: 'dlNme', header: 'Deal Name' },
      { field: 'coltRefNo', header: 'Collateral Reference #' },
      { field: 'aqsnDealId', header: 'Acquisition Deal ID' },
      { field: 'aqsnDt', header: '(Est.) Acquisition Date' },
      { field: 'reqdSubmtDt', header: 'Required Submission Date' },
      { field: 'maxSubmtDt', header: 'Last Submitted Date' },
      { field: 'complianceRate', header: 'Status' }
    ];

    this.showHideDownloadButton();
    this.showHideUploadPCAButton();
  }

  private showHideDownloadButton() {
    if (this.countDiaplayedAqsnList > 0)
      this.enableDownloadButton = true;
    else
      this.enableDownloadButton = false;

    //Set the show/hide based on the user role
    this.showDownloadButton = true;
    if (this.userRoles) {
      if (this.userRoles.isMAUser || this.userRoles.isAssetManager) {
        this.showDownloadButton = false;
      }
      if (this.userRoles.isExternalUser || this.userRoles.isAdminUser || this.userRoles.isMFOpsUser) {
        this.showDownloadButton = true;
      }
    }
  }
  private showHideUploadPCAButton() {
    //Set the show/hide based on the user role 
    if (this.userRoles) {
      if (this.userRoles.isAssetManager) {
        this.showUploadPCAButton = true;
      }
      if (this.userRoles.isExternalUser || this.userRoles.isAdminUser || this.userRoles.isMFOpsUser || this.userRoles.isMAUser) {
        this.showUploadPCAButton = false;
      }
    }
  }

  public loadAcquistionTabData() {
    if (this._acqnDetails.acqnDashboardDetails) {
      this.acqnDetailsDashboardDisplay = this._acqnDetails.acqnDashboardDetails;
      this.acqnDetailsDashboardDisplayTemp = this._acqnDetails.acqnDashboardDetails;
      this.getAcquisitionDashboardCounts();
      this.countDiaplayedAqsnList = this._acqnDetails.acqnDashboardDetails.length;
    } else {
      this.acqnDetailsDashboardDisplay = [];
      this.numberOfAcquisitions = 0;
      this.complianceRateAcquisitions = 0;
      this.submissionRateAcquisitions = 0;
      this.countDiaplayedAqsnList = 0;
    }

    this.selectedReportArrayDisplay = [];
    this.loadDropDownFilterLists();
    this.showHideDownloadButton();
    this.showHideUploadPCAButton();

  }

  public getAcquisitionDashboardCounts() {
    // console.log("acquisitions.component.ts::getAcquisitionDashboardCounts - compliance calculation, this.acqnDetailsDashboardDisplay = ", this.acqnDetailsDashboardDisplay);

    if (this.acquisitionStatusFilterSelected == 'Pre-Acquisition') {
      this.numberOfAcquisitions = 'N/A';
      this.complianceRateAcquisitions = 'N/A';
      this.submissionRateAcquisitions = 'N/A';
    } else {
      // get number of pre-acquisition deals
      this.numberOfPreAcquisitionDeals = _.filter(this.acqnDetailsDashboardDisplay, function (o) { return o.acquisitionStatus == 'Pre-Acquisition' }).length;

      // get number of acquisitions by finding how many acquisition deal ids
      this.numberOfAcquisitions = _.filter(this.acqnDetailsDashboardDisplay, function (o) { return o.acquisitionStatus == 'Acquired' }).length;

      // get report counts
      let submittedCount = 0;
      let pcaNCount = 0;
      let esaNCount = 0;
      let zonNCount = 0;
      let sraNCount = 0;
      let apprNCount = 0;
      let compliantCount = 0;
      let nonCompliantCount = 0;
      for (let i = 0; i < this.acqnDetailsDashboardDisplay.length; i++) {
        //skip if pre-acquisition deal
        if (this.acqnDetailsDashboardDisplay[i].acquisitionStatus == 'Acquired') {
          //PCA
          if (this.acqnDetailsDashboardDisplay[i].pca == 'Y') {
            submittedCount++;
          } else if (this.acqnDetailsDashboardDisplay[i].pca == 'N') {
            pcaNCount++;
          }
          //ESA
          if (this.acqnDetailsDashboardDisplay[i].esa == 'Y') {
            submittedCount++;
          } else if (this.acqnDetailsDashboardDisplay[i].esa == 'N') {
            esaNCount++;
          }
          //ZON
          if (this.acqnDetailsDashboardDisplay[i].zon == 'Y') {
            submittedCount++;
          } else if (this.acqnDetailsDashboardDisplay[i].zon == 'N') {
            zonNCount++;
          }
          //SRA
          if (this.acqnDetailsDashboardDisplay[i].sra == 'Y') {
            submittedCount++;
          } else if (this.acqnDetailsDashboardDisplay[i].sra == 'N') {
            sraNCount++;
          }
          //APR
          if (this.acqnDetailsDashboardDisplay[i].appr == 'Y') {
            submittedCount++;
          } else if (this.acqnDetailsDashboardDisplay[i].appr == 'N') {
            apprNCount++;
          }
          //Compliant
          switch (this.acqnDetailsDashboardDisplay[i].complianceRate.toLowerCase()) {
            case "compliant":
              compliantCount++;
              break;
            case "non-compliant":
              nonCompliantCount++;
              break;
            default:
              break;
          }
        }
      }
      // get compliance rate
      if (compliantCount + nonCompliantCount != 0)
        this.complianceRateAcquisitions = compliantCount / (compliantCount + nonCompliantCount);
      else
        this.complianceRateAcquisitions = 0;

      // get submission rate
      if (submittedCount + pcaNCount + esaNCount + zonNCount + sraNCount + apprNCount != 0)
        this.submissionRateAcquisitions = submittedCount / (submittedCount + pcaNCount + esaNCount + zonNCount + sraNCount + apprNCount);
      else
        this.submissionRateAcquisitions = 0;
    }

    this.onUpdateLenderStats();
  }

  public resetDropDownPlaceHolders(field: string) {
    if (field == 'purpsTypSpmt') {
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'refType') {
      this.lnPurpsTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'lnBalance') {
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'transType') {
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
    } else if (field == 'acquisitionStatus') {
      this.acqsnSelectedLender = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'tabChange') {
      this.acqsnSelectedLender = '';
      this.acquisitionStatusFilterSelected = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else {
      this.acquisitionStatusFilterSelected = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    }
  }

  public loadDropDownFilterLists() {
    // Lender Names
    if (this._acqnDetails.lenderNames) {
      this.acqsnLenderList = [{ label: 'All', value: '' }];
      if (this._acqnDetails.lenderNames) {
        for (let i = 0; i < this._acqnDetails.lenderNames.length; i++) {
          this.acqsnLenderList.push({ label: this._acqnDetails.lenderNames[i], value: this._acqnDetails.lenderNames[i] });
        }
        this.acqsnLenderList = _.sortBy(this.acqsnLenderList, ['value']);
      }
    } else {
      this.acqsnLenderList = [{ label: 'All', value: '' }];
    }

    // Acquisition Dashboard Details
    if (this._acqnDetails.acqnDashboardDetails) {
      let tempVar: any[];

      // acquisition status
      this.acquisitionStatusFilterList = [
        { label: 'All', value: '' },
        { label: 'Acquired', value: 'Acquired' },
        { label: 'Committed', value: 'Pre-Acquisition' }
      ];

      // loan purpose type(s)
      this.lnPurpsTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqnDashboardDetails.map((o) => o.purpsTypSpmt))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnPurpsTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnPurpsTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // loan refinance type(s)
      this.lnRefiTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqnDashboardDetails.map((o) => o.refType))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnRefiTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnRefiTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // loan balance indicator(s)
      this.lnBalanceList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqnDashboardDetails.map((o) => o.lnBalance))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnBalanceList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnBalanceList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // transaction type(s)
      this.txTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqnDashboardDetails.map((o) => o.transType))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.txTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.txTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }
      //this.txTypeList = _.sortBy(this.txTypeList, ['value']);
    } else {
      this.lnPurpsTypeList = [{ label: 'All', value: '' }];
      this.lnRefiTypeList = [{ label: 'All', value: '' }];
      this.lnBalanceList = [{ label: 'All', value: '' }];
      this.txTypeList = [{ label: 'All', value: '' }];
    }
  }

  public applyFilters() {
    this.acqnDetailsDashboardDisplay = this._acqnDetails.acqnDashboardDetails;

    //acquisition status
    if (this.acquisitionStatusFilterSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['acquisitionStatus', this.acquisitionStatusFilterSelected])

    //lender
    if (this.acqsnSelectedLender != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['lender', this.acqsnSelectedLender])

    //supplemental
    if (this.lnPurpsTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['purpsTypSpmt', this.lnPurpsTypeSelected])

    //loan refinance type
    if (this.lnRefiTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['refType', this.lnRefiTypeSelected])

    //small loan balance
    if (this.lnBalanceSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['lnBalance', this.lnBalanceSelected])

    //transaction type
    if (this.txTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['transType', this.txTypeSelected])

    //recalculate dashboard metrics
    this.getAcquisitionDashboardCounts();
    //this.countAqsnList = _.filter(this.acqnDetailsDashboardDisplay, {active: true}).map((item, index) => ({item:this.acqnDetailsDashboardDisplay,counter:index+1}));
    this.countDiaplayedAqsnList = this.acqnDetailsDashboardDisplay.length;
    this.showHideDownloadButton();
    
  }

  // Do a callback and refresh the acqnDetails
  public onRefreshAcqnDetails() {
    // Get start and end date and do a callback to get a new list
    let startDate: string = this.selectedStartPeriod;
    let endDate: string = this.selectedEndPeriod;
    let isLenderRanking: boolean = false;

    this.refreshAcqnDetails.emit({ startDate, endDate, isLenderRanking });
  }

  onGetEndPeriodDates() {
    // Get start and end date and do a callback to get a new list
    let startDate: string = this.selectedStartPeriod;
    let endDate: string = this.selectedEndPeriod;
    let isLenderRanking: boolean = false;
    let onload: boolean = false;

    this.getEndPeriodDates.emit({ startDate, endDate, isLenderRanking, onload });
  }

  showUpdateReportComponent() {
    this.showAcqnUpdateComponent = true;
  }

  onAcqnUpdateTableClose(refresh: boolean) {
    console.log("acquisitions.component.ts::onAcqnUpdateTableClose - refresh = ", refresh);
    
    this.showAcqnUpdateComponent = false;
    if (refresh) {
      this.onRefreshAcqnDetails();
    }
  }

  onUpdateLenderStats() {
    let lenderStats = {
      noAcquisitions: this.numberOfAcquisitions,
      rateCompliance: this.complianceRateAcquisitions,
      rateSubmission: this.submissionRateAcquisitions
    } as StatsDataDetails;

    this.statsDataService.setStatsDataDetails(lenderStats);
    this.statsDataService.notifySubscribers();
  }

  showAcqnFilterSidebar() {
    this.acqnFiltersService.setSource(FilterDetailsSourceType.Acquisitions);
    this.acqnFiltersService.setStartPeriod(this.selectedStartPeriod);
    this.acqnFiltersService.setEndPeriod(this.selectedEndPeriod);

    this.acqnFiltersService.setIsInternal(this.isInternal);
    if (this.isInternal) {
      this.acqnFiltersService.setLender(this.acqsnSelectedLender);
      this.acqnFiltersService.setLenderList(this.acqsnLenderList);
    }

    this.acqnFiltersService.setAcquisitionStatus(this.acquisitionStatusFilterSelected);
    this.acqnFiltersService.setAcquisitionStatusList(this.acquisitionStatusFilterList);

    this.acqnFiltersService.setSupplemental(this.lnPurpsTypeSelected);
    this.acqnFiltersService.setSupplementalList(this.lnPurpsTypeList);

    this.acqnFiltersService.setLoanRefinanceType(this.lnRefiTypeSelected);
    this.acqnFiltersService.setLoanRefinanceTypeList(this.lnRefiTypeList);

    this.acqnFiltersService.setSmallLoanBalance(this.lnBalanceSelected);
    this.acqnFiltersService.setSmallLoanBalanceList(this.lnBalanceList);

    this.acqnFiltersService.setTransactionType(this.txTypeSelected);
    this.acqnFiltersService.setTransactionTypeList(this.txTypeList);

    this.acqnFiltersService.notifySubscribers();

    this.openAcqnFilterSidebar.emit(true);
  }

  showAcqnPropertyDetailsSidebar(rowData: any) {
    let source = this.acqnFiltersService.getSource();
    if (source == "" || source == 'AcquisitionsPropertyDetails') {
      this.acqnFiltersService.setSource('AcquisitionsPropertyDetails');
      this.selectedPropertyDetails.emit(rowData);
      this.openAcqnPropertyDetailsSidebar.emit(true);
    }
  }

  public downloadAcquisitionDealDetails(filteredData: AcqnDashboardDetails[]) {
    if (filteredData == null) {
      filteredData = this.acqnDetailsDashboardDisplay;
    }

    if (this.acquisitionStatusFilterSelected == 'Pre-Acquisition') {
      this.acquisitionStatusFilterSelected = 'Committed';
    }

    this.acqnDownloadService.exportToExcel(filteredData,
      {
        tableSearchText: this.tableSearchText,
        startDate: this.selectedStartPeriod,
        endDate: this.selectedEndPeriod,
        isInternal: this.isInternal,
        selectedLender: this.acqsnSelectedLender,
        acquisitionStatus: this.acquisitionStatusFilterSelected,
        supplemental: this.lnPurpsTypeSelected,
        loadFinanceType: this.lnRefiTypeSelected,
        smallLoanBalance: this.lnBalanceSelected,
        transactionType: this.txTypeSelected
      });
  }

  public onFilteredAcqnTable(acqntbl) {
    this.tableSearchText = acqntbl.filters.global?.value || '';

    const filteredData = acqntbl.filteredValue;
    this.countDiaplayedAqsnList = filteredData?.length || this._acqnDetails.acqnDashboardDetails.length;

    this.showHideDownloadButton();
  }

    showUploadFilesDialog(flag: boolean) {
        // if (this.systemDownFlagValue) {
        //   this.apiService.shutDownApp = true;
        //   this.router.navigate([''], { skipLocationChange: true });
        //   return;
        // }
        let showUploadFiles = flag;
        this.propertyFileUploadPCADetails.emit({showUploadFiles });
        this.fileUploadService.setSource(FileUploadSourceType.AcquisitionPropertyDetails);    
     }
  

}
